import Vue from 'vue'
import Router from 'vue-router'

// 加载组件
import index from '@/components/index'
const NotFound = { template: '<p>Page not found</p>' }

Vue.use(Router)

export default new Router({
  mode:'history',
  routes: [
    {
      path: '/',
      name:'index',
      meta:{title:'杭州美氟制冷科技有限公司'},
      component: index
    },{
      path:'*',
      component:NotFound
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js